<ng-container [ngSwitch]="renderType">
  <img
    #img
    *ngSwitchCase="0"
    [style.visibility]="loaded ? 'visible' : 'hidden'"
    (dragstart)="$event.preventDefault()"
    decoding="auto"
    draggable="false"
    [src]="src"
    [alt]="alt"
    (load)="onImageLoad(img)"
    txtbFixRender
    [imgSrc]="imgSrc"
    txtbProportionalImage
    [isScrolled]="isScrolled"
    [class.scale-to-height]="!verticalScroll && imagesScalingEnabled && (horizontalScroll || (scaleImageToHeight$ | async) === true)"
    [class.scale-to-width]="!horizontalScroll && imagesScalingEnabled && (verticalScroll || (scaleImageToWidth$ | async) === true)"
    [style.--percentage-scale]="(percentageScale || MAX_PERCENT) + '%'"
    [ngClass]="{fluid, center}"
  />
  <img
    #img
    *ngSwitchCase="1"
    [style.visibility]="loaded ? 'visible' : 'hidden'"
    (dragstart)="$event.preventDefault()"
    decoding="auto"
    draggable="false"
    [src]="src"
    [alt]="alt"
    (load)="onImageLoad(img)"
    txtbProportionalImage
    [isScrolled]="isScrolled"
    [class.scale-to-height]="!verticalScroll && imagesScalingEnabled && (horizontalScroll || (scaleImageToHeight$ | async) === true)"
    [class.scale-to-width]="!horizontalScroll && imagesScalingEnabled && (verticalScroll || (scaleImageToWidth$ | async) === true)"
    [style.--percentage-scale]="(percentageScale || MAX_PERCENT) + '%'"
    [ngClass]="{fluid, center}"
  />
  <img
    #img
    *ngSwitchCase="2"
    [style.visibility]="loaded ? 'visible' : 'hidden'"
    (dragstart)="$event.preventDefault()"
    decoding="auto"
    draggable="false"
    [src]="src"
    [alt]="alt"
    (load)="onImageLoad(img)"
    txtbProportionalImage
    [isScrolled]="isScrolled"
    txtbFixRender
    [imgSrc]="imgSrc"
    [class.scale-to-height]="!verticalScroll && imagesScalingEnabled && (horizontalScroll || (scaleImageToHeight$ | async) === true)"
    [class.scale-to-width]="!horizontalScroll && imagesScalingEnabled && (verticalScroll || (scaleImageToWidth$ | async) === true)"
    [style.--percentage-scale]="(percentageScale || MAX_PERCENT) + '%'"
    [ngClass]="{fluid, center}"
  />
  <txtb-zoom-image
    *ngSwitchCase="3"
    (loaded)="onImageLoad(null)"
    [style.visibility]="loaded ? 'visible' : 'hidden'"
    [imageData]="imageData"
    [scrollDisabled]="scrollDisabled"
    [imagesScalingEnabled]="imagesScalingEnabled"
    [percentageScale]="percentageScale"
  ></txtb-zoom-image>
  <img
    #img
    *ngSwitchDefault
    [style.visibility]="loaded ? 'visible' : 'hidden'"
    (dragstart)="$event.preventDefault()"
    decoding="auto"
    draggable="false"
    [src]="src"
    [alt]="alt"
    (load)="onImageLoad(img)"
    [class.scale-to-height]="!verticalScroll && imagesScalingEnabled && (horizontalScroll || (scaleImageToHeight$ | async) === true)"
    [class.scale-to-width]="!horizontalScroll && imagesScalingEnabled && (verticalScroll || (scaleImageToWidth$ | async) === true)"
    [style.--percentage-scale]="(percentageScale || MAX_PERCENT) + '%'"
    [ngClass]="{ start }"
  />
</ng-container>

<div *ngIf="!loaded" class="spinner-wrapper">
  <txtb-spinner></txtb-spinner>
</div>
